import {
    GET_WIKI_PAGES,
    ADD_WIKI_PAGE,
    UPDATE_WIKI_PAGE,
    WIKI_ERROR
} from '../actions/types';

const initialState = {
    wikiPage: null,
    wikiPages: [],
    loading: true,
    error: {}
}

function wikiReducer(state = initialState, action) {

    const { type, payload } = action;
    
    switch(type){
        case ADD_WIKI_PAGE:
        case UPDATE_WIKI_PAGE:
            return {
                ...state,
                wikiPage: payload,
                wikiPages: [],
                loading: false
            };
        case GET_WIKI_PAGES:
            return {
                ...state,
                wikiPages: payload,
                wikiPage: null,
                loading: false
            };
        case WIKI_ERROR:
            return{
                ...state,
                error: payload
            };
        default:
            return state;
    }
}

export default wikiReducer;